<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>反匹配待处理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.rel_type">
                <vDropdown
                    model_key="rel_type"
                    model_name="请选择关联类型"
                    select_value="value"
                    request_uri="dropDownTransactionFlowPendingType"
                    :model_value_default="queryParams['rel_type']"
                    @onDropChange="onDropChange"
                    ref="rel_type_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.rel_rid_in_detail">
                <el-input v-model="queryParams['rel_rid_in_detail']" placeholder="请输入关联RID" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.process_status">
                <vDropdown
                    model_key="process_status"
                    model_name="请选择处理状态"
                    select_value="value"
                    request_uri="dropDownTransactionFlowPendingProcessStatus"
                    :model_value_default="queryParams['process_status']"
                    @onDropChange="onDropChange"
                    ref="process_status_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.is_negative">
                <vDropdown
                    model_key="is_negative"
                    model_name="是否包含负流向类型"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['is_negative']"
                    @onDropChange="onDropChange"
                    ref="is_negative_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.business_rid">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="queryParams['date']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="updateOrCreate" v-if="postList.addBtn" :loading="btnLoading">新增或更新</el-button>
                <el-button size="small" plain @click="batchProcess" v-if="postList.addBtn" :loading="btnLoading">批量处理</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload
                        obj="transaction_flow_pending"
                        :display_insert="false"
                        :display_update="false"
                        :display_updateOrCreate="true"
                        :queryParams="queryParams"
                    ></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <div v-show="is_show_help">
                <div class="flex btn_tips">
                    1.
                    新增或更新：同维度待处理会合并成一条，日期根据最早的那个关联ID走（忽略负流向类型，该类型会忽略日期进行维度锁定，有单独的界面进行关联正流向，以及批量处理）
                </div>
                <div class="flex btn_tips">
                    2.
                    批量处理：批量把复选框选中的待处理（建议筛选为待处理、非负流向类型的再进行勾选，如果勾选已处理的或负流向类型，后台会忽略）对应的日期后面的同维度的匹配解绑（业务与流向、流向与往来），然后标记为已处理（不会进行重新匹配）
                </div>
                <div class="flex btn_tips">3. 批量处理不会对正负流向核销进行解绑，除非对应的正流向或负流向被删除</div>
                <div class="flex btn_tips">4. 批量处理不会对人工标记为不处理的业务、流向、终端授权进行处理</div>
                <div class="flex btn_tips">5. 终端授权解绑前，会对相关的合作往来限额进行解绑，不会对业务和流向的匹配进行解绑</div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight + 30"
                class="transaction_flow_pending"
                @header-dragend="changeColWidth"
                @selection-change="selectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['rid', 'business_name', 'product_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'transactionFlowPendingComponent',
    data() {
        return {
            draggable: {
                data_name: 'transaction_flow_pending'
            },
            is_show_help:false,
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            selected: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help(){
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['rid']) && row.rid) {
                this.$router.push({
                    path: '/transactionFlowPendingDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'business_name' && row.business_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.business_rid
                    }
                });
            } else if (prop == 'product_name' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            }

            // else if (prop == 'rel_rid' && row.rel_rid != '' && row.rel_type != '') {
            //     if (in_array(row.rel_type, [1, 2, 5, 6])) {
            //         // 没做详情页
            //     } else if (in_array(row.rel_type, [3, 4])) {
            //             // 那这个也不跳了
            //     }
            // }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                rel_type: '',
                rel_rid_in_detail: '',
                process_status: 1,
                is_negative: 2,
                business_rid: '',
                product_rid: '',
                date: ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = [];
            for (let i in val) {
                this.selected.push(val[i]['rid']);
            }
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('transaction_flow_pending_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('transaction_flow_pending_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('transaction_flow_pending', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).transaction_flow_pending;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'transactionFlowPendingLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        //新增或更新
        updateOrCreate() {
            this.$router.push({
                path: 'transactionFlowPendingEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        batchProcess() {
            if (this.selected.length == 0) {
                this.$message.warning('至少勾选一项');
                return false;
            }

            this.$confirm('您确定要批量处理吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionFlowPendingBatchProcess']({
                        rid: this.selected
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'transactionFlowPendingDelete', row.name);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
.btn_tips {
    color: red;
    font-size: 12px;
}
</style>